export default __webpack_public_path__ + "static/media/selectUnselectedBlack.d356766b.svg";